import { 
    createSlice, 
    createAsyncThunk,  
    createEntityAdapter,
    createSelector,  
} from '@reduxjs/toolkit'
import { Pager } from '../../../lib/js-apiclient/src/response/Pager';
import { FarfetchModel } from '../models/farfetch/FarfetchModel';


const farfetchCollectionAdapter = createEntityAdapter({})

export const farfetchCollectionApi = {
    _model: null,
    _getToken: (thunkAPI) => {
        return thunkAPI.getState().identityReducer.token.signature;
    },
    fetchAll: createAsyncThunk(
        'farfetch/collection/fetchAll', 
        async ({channelId, page, term}, thunkAPI) => {
            try {
                const token = farfetchCollectionApi._getToken(thunkAPI);
                const farfetchModel = new FarfetchModel(token, channelId);

                // /** @type {Pager} */
                // const pager = await farfetchModel.getCollections(page, term);
                
                // return {
                //     hasPrevPage: pager.hasPrevPage,
                //     hasNextPage: pager.hasNextPage,
                //     entities: pager.getEntities()
                // }
                const collections = await farfetchModel.getCollections(page, term);
                
                return {
                    hasPrevPage: false,
                    hasNextPage: false,
                    entities: collections,
                }
            } catch (apiError) {
                return thunkAPI.rejectWithValue(apiError.toJson());
            }
        }
    ),
}

const farfetchCollectionSlice = createSlice({
    name: "farfetch/collection",
    initialState: farfetchCollectionAdapter.getInitialState({
        status: 'idle',
        error: null,
        showMore: true,
    }),
    reducers: {
        clearCollectionList(state, action) {
            farfetchCollectionAdapter.removeAll(state);
        },
    },
    extraReducers: {
        [farfetchCollectionApi.fetchAll.fulfilled]: (state, action) => {
            state.status = 'farfetch/collection/fetchAll/succeeded'

            if(action.payload.hasPrevPage) {
                farfetchCollectionAdapter.addMany(state, action.payload.entities)
            } else {
                farfetchCollectionAdapter.setAll(state, action.payload.entities)
            }

            state.showMore = action.payload.hasNextPage;
            state.error = null;
        },
        [farfetchCollectionApi.fetchAll.rejected]: (state, action) => {
            state.status = 'farfetch/collection/fetchAll/rejected'
            state.error = action.payload
        },
    }
});

export const selectFarfetchCollections = createSelector(
    (state, _) => selectAllFarfetchCollections(state),
    (_, filter) => filter,
    (items, filter) => {
        return (filter !== undefined && filter !== null && filter !== null) 
            ? items.filter((item) => {
                return item.name.startsWith(filter);
              })
            : items
    }
  );

export const {
    selectAll: selectAllFarfetchCollections,
} = farfetchCollectionAdapter.getSelectors((state) => state.farfetchCollectionReducer)

export const { clearCollectionList } = farfetchCollectionSlice.actions;

export default farfetchCollectionSlice.reducer;
